import { Button, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import strings from '../Globalization';
import consts from '../consts';
import Model from '../models/model';
import Connection from '../services/Connection';

const handlePreview = (params) => {
	let url = `${consts.hostURL.URL}${Connection.PreviewDocument}?type=document&id=${params.row.AttachmentId}`;
	window.open(url, 'Preview Documnet');
}

const model = new Model({
	name: 'Attachment',
	title: 'Attachment',
	defaultSort: 'Filename ASC',
	disableDelete: true,
	disableAdd: true,
	disableExport: true,
	disableColumnSelector: true,
	disableFiltering: true,
	readOnly: true,
	idProperty: 'AttachmentId',
	formTitleField: 'FileName',
	gridTitle: 'Attachment',
	showGridRefreshBtn: true,
	customizeSaveData: (toSave, { activeRecord }) => {
		if (!activeRecord?.record?.AttachmentTypeId || !activeRecord?.record?.AssociationTypeId) {
			activeRecord.record.AttachmentTypeId = 0;
			activeRecord.record.AssociationTypeId = 1;
		}
		return { ...toSave, ...activeRecord.record }
	},
	columns: [
		{ header: 'UniqueId', field: 'AttachmentId', width: 250, hide: true, isNotformfield: true },
		{ header: 'FileName', field: 'Filename', width: 400, isNotformfield: true },
		{ header: 'Description', field: 'Description', width: 160, inlineLabelSize: 12, multiline: true, rows: 2, maxLength: 250 },
		{ header: 'Date', field: 'CreatedOn', width: 160, type: 'date', isLocal: true, isNotformfield: true },
		{
			header: 'File',
			field: 'selectFile',
			type: 'file',
			required: true,
			hideLabel: true,
			excludeOnGrid: true,
			customizeInput: ({ Input, inputProps }) => {
				const { formik } = inputProps;
				return (
					<Grid container size={12}>
						<Grid size='grow'>
							<Input {...inputProps} />
						</Grid>
						<Grid
							size='auto'
							sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}
						>
							<Button variant="contained" color='warning' onClick={formik.handleSubmit} size="small" >
								{strings.UploadImage}
							</Button>
						</Grid>
					</Grid>
				);
			}
		},
		{
			field: 'Delete',
			header: 'Delete',
			width: 150,
			type: 'action',
			isNotformfield: true,
			action: 'delete',
			renderCell: (params) => (
				<Button
					onClick={() => {
						params.colDef.deleteRow(params);
					}}
					color="error"
					variant="contained"
					startIcon={<DeleteIcon fontSize="inherit" />}
					title={strings.Delete}
					size="small"
				>
					{strings.Delete}
				</Button>
			)
		},
		{
			field: 'Preview',
			header: 'Preview',
			width: 150,
			type: 'action',
			isNotformfield: true,
			renderCell: (params) => (
				<Button
					variant="contained"
					title={strings.PrintPreview}
					onClick={() => handlePreview(params)}
					size="small"
					disabled={params.row?.interfacedYN}
				>
					{strings.PrintPreview}
				</Button>
			)
		}
	]
});

export const CycleAttachmentModel = model

export default model.createFormBase();
